import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import TracksDropdown from 'components/dropdowns/TracksDropdown.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class MidiOutputterComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    getParameterOptions() {
        return this.props.sequencerEngine.tracks.map(
            track => ({
                label: track.trackNumber + 1,
                value: track}));
    }

    getParameterOption(o) {
        if (o === undefined) {
            return undefined;
        }
        o = this.props.sequencerEngine.tracks[o];
        let filtered = this.getParameterOptions().filter(
            x => x.value === o);

        return filtered.length > 0 ? filtered[0] : undefined;
    }

    onSelectTrack(track) {
        this.props.effect.trackOutput = track === null ? undefined : track.trackNumber;
        this.setState(this.state);
    }

    get track() {
        return this.props.sequencerEngine.tracks[this.props.effect.trackOutput];
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <TracksDropdown
                  track={this.track}
                  onSelectTrack={(track) => this.onSelectTrack(track)}
                  sequencerEngine={this.props.sequencerEngine}/>
                <div className="clear-fix"/>
               <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Probability'}
                  parameter={this.props.effect.probabilityParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0}
                  max={100}/>
              </ConditionedComponent>
            </div>
        );
    }
}

export default MidiOutputterComponent;
